import { render, staticRenderFns } from "./PagerComponent.vue?vue&type=template&id=4d79acfc&scoped=true&"
import script from "./PagerComponent.vue?vue&type=script&lang=js&"
export * from "./PagerComponent.vue?vue&type=script&lang=js&"
import style0 from "./PagerComponent.vue?vue&type=style&index=0&id=4d79acfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d79acfc",
  null
  
)

export default component.exports